/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ElectricalSettingsReturnCodes } from './electrical-settings-return-codes';

export class ElectricalSettingsStatusResult {
  result: ElectricalSettingsStatusChanges[];
}

export class ElectricalSettingsStatusChanges {
  settingName: string;
  returnCodes: ElectricalSettingsReturnCodes;
  applicationName: string;
}
